module.exports = __webpack_public_path__ + "files/136eae758a5b4ca95c7b42ba38763fc1.png";